export const processMiningTranslations = {
  en: {
    processMining: "Process Mining",
    processMiningDescription: "Application for analyzing process data",
    dataQuality: "Data Quality",
    dataQualityDescription: "Analyzing and improving data quality",
    overallQualityScore: "Overall Quality Score",
    tablesCount: "Tables Count",
    averageScore: "Average Score",
    percentOfRecordsHaveMissingValues:
      "{percent}% of records have missing values",
    qualityIssues: "Quality Issues",
    fieldAnalysis: "Field Analysis",
    startAnalysis: "Start Analysis",
    analysisNotStartedYetMessage:
      "Analysis not started yet, click on {0} to start the analysis.",
    analysisFailedMessage:
      "Analysis failed, click on {0} to retry the analysis.",
    tableAnalysisStatusinitial: "Not started",
    tableAnalysisStatusanalyzing: "In progress",
    tableAnalysisStatusdone: "Completed",
    tableAnalysisStatuserror: "Failed",
    overallScore: "Overall Score",
    distinctValues: "Distinct Values",
    missingValues: "Missing Values",
    analysisAlreadyRunning: "Analysis is already running.",
    nOfmEntriesAffected: "{n} of {m} entries affected",
    columnOrder: "Column Order",
    numericOutliers: "Numeric Outliers",
    inconsistentNumbers: "Inconsistent Numbers",
    blankStrings: "Blank Strings",
    inconsistentDates: "Inconsistent Dates",
    invalidEmails: "Invalid Emails",
    processLogs: "Process Logs",
    processLogsDescription: "Manage process event logs",
    noEventLogsFound: "No event logs found",
    entries: "Entries",
    firstEntryDate: "First Entry",
    lastEntryDate: "Last Entry",
    caseId: "Case ID",
    activity: "Activity | Activities",
    timestamp: "Timestamp",
    endTime: "End Time",
    activityLogs: "Activities",
    nonEmptyEntries: "Non-empty Entries",

    numericOutliersNegated: "Values within normal range",
    blankStringsNegated: "Non-empty strings",
    missingValuesNegated: "Non-null values",
    inconsistentNumbersNegated: "Consistent Numbers",
    inconsistentDatesNegated: "Consistent Dates",
    invalidEmailsNegated: "Valid Email Addresses",
    analysisNotStarted: "Analysis not started",
    errorAnalyzing: "Error analyzing",
    analyzing: "Analyzing",
    analyzed: "Analyzed",
    noAnalysis: "No analysis",
    analysisStarted: "Analysis started",
    syncingStarted: "Syncing started",
    deleted: "Deleted",
    tableDeleted: "This table has been deleted from the database",
    syncing: "Syncing",
    syncError: "Error syncing",
    newAnalysis: "New Analysis",
    pmNoVariantSelected:
      "Please select at least one variant to display the BPMN diagram.",
    pmNoCaseSelected: "Please select a case to display the BPMN diagram.",
    noStepInstances: "No step instances found for this case.",
    ongoingStep: "Ongoing (no end time recorded)",
    start: "Start",
    end: "End",
    duration: "Duration",
    variantFilter: "Variants",
    caseFilter: "Case",
    nEvents: "{n} events",
    selectAll: "Select All",
    selectAllTablesConfirm:
      "Do you want to select all {count} tables? This will load all remaining tables.",
    case: "Case | Cases",
    selectCase: "Select case",
    downloadBpmn: "Download BPMN",
    zoomIn: "Zoom In",
    zoomOut: "Zoom Out",
    resetZoom: "Reset Zoom",
    operation: "Operation",
    editActivity: "Edit Activity",
    processVariants: "Process Variants",
    kpiThresholdsInfo:
      "These thresholds determine the color coding of the KPI display (Red/Yellow/Green). The best achievable value is 100.",

    // KPI Filter translations
    editKpiFilters: "Edit KPI Filters",
    editTableFilters: "Edit Table Filters",
    tableFiltersDescription:
      "Table filters apply to all fields during analysis. They filter the rows considered for quality metrics across the entire table.",
    filterOperator: "Operator",
    filterField: "Field",
    filterCondition: "Condition",
    filterValue: "Value",
    addFilter: "Add Filter",
    removeFilter: "Remove Filter",
    filterOperatorAND: "AND",
    filterOperatorOR: "OR",
    filterConditionEquals: "Equals",
    filterConditionNotEquals: "Not Equals",
    filterConditionGreaterThan: "Greater Than",
    filterConditionLessThan: "Less Than",
    filterConditionGreaterThanOrEqual: "Greater Than or Equal",
    filterConditionLessThanOrEqual: "Less Than or Equal",
    filterConditionContains: "Contains",
    filterConditionNotContains: "Not Contains",
    noFiltersConfigured: "No filters configured",
    filtersActive: "{count} filter(s) active",
    selectFieldFirst: "Select field first",
    filtersNotApplied:
      "Some filters have not been applied to the current analysis. Please refresh to apply changes.",
    refreshToApplyFilters: "Refresh to apply filters",
    startAnalysisForAllTables: "Start Analysis for All Tables",
    startAnalysisForAllTablesConfirm:
      "Start analysis for all tables? This may take some time.",
    processWorkbench: "Process Workbench",
    rawActivities: "Raw Activities",
    processSteps: "Process Steps",
    totalActivities: "Total Activities",
    unmappedActivities: "Unmapped",
    listView: "List",
    flowView: "Flow",
    eventsView: "Events",
    selectCaseToViewEvents: "Select a case to view events",
    failedToLoadEventEntries: "Failed to load event entries",
    noEventEntriesFound: "No event entries found",
    createProcessStep: "Create Process Step",
    deleteRule: "Delete Rule",
    activityDetails: "Activity Details",
    processStepDetails: "Process Step Details",
    details: "Details",
    selectActivityOrStep: "Select an activity or process step to view details",
    assignedToStep: "Assigned to Step",
    strategy: "Strategy",
    manualAssignment: "Manual Assignment",
    assignedActivities: "Assigned Activities",
    noActivitiesAssigned: "No activities assigned yet",
    noStepsYet: "No process steps found",
    noActivitiesFound: "No activities found",
    processStepCreated: "Process step created successfully",
    stepNameUpdated: "Step name updated successfully",
    variantNameUpdated: "Variant name updated successfully",
    strategyUpdated: "Strategy updated successfully",
    stepDeleted: "Step deleted successfully",
    activityAssigned: "Activity assigned successfully",
    activityUnassigned: "Activity unassigned successfully",
    failedToCreateStep: "Failed to create process step",
    failedToUpdateStep: "Failed to update process step",
    failedToUpdateVariant: "Failed to update variant",
    failedToDeleteStep: "Failed to delete process step",
    failedToAssignActivity: "Failed to assign activity",
    failedToUnassignActivity: "Failed to unassign activity",
    pleaseEnterStepName: "Please enter a step name",
    confirmDelete: "Are you sure you want to delete this step?",
    workbench: "Workbench",
    columnChange: "Column Change",
    timeWindow: "Time Window",
    stateBased: "State Based",
    stateBasedSettings: "State-Based Settings",
    editStateBasedStrategy: "Edit Strategy",
    stateBasedStrategyDescription:
      "State-based strategy groups events into process steps based on conditions. Events are grouped together if they occur within the specified time window and match all conditions.",
    condition: "Condition | Conditions",
    addCondition: "Add Condition",
    noConditionsSet: "No conditions set",
    selectTable: "Select Table",
    column: "Column | Columns",
    maxTimeBetweenEvents: "Max Time Between Events",
    useDragAndDropToAssignAnActivityToAStep:
      "Use drag and drop to assign an activity to a step",

    // Process Step Rules
    processStepRules: "Process Step Rules",
    createProcessStepRule: "Create Process Step Rule",
    createRule: "Create Rule",
    enterRuleName: "Enter rule name",
    noRulesYet: "No process step rules found",
    ruleDetails: "Rule Details",
    stepDetails: "Step Details",
    generatedSteps: "Generated Steps",
    generatedBy: "Generated by rule",
    ruleCreated: "Rule created successfully",
    ruleNameUpdated: "Rule updated successfully",
    ruleDeleted: "Rule deleted successfully",
    failedToCreateRule: "Failed to create rule",
    failedToUpdateRule: "Failed to update rule",
    failedToDeleteRule: "Failed to delete rule",
    confirmDeleteRule: "Are you sure you want to delete this rule?",
    assignedToRule: "Assigned to Rule",
    stepsGenerated: "{count} step | {count} steps",
    ignoreInAnalysis: "Ignore in Analysis",
    stepMetadata: "Step Metadata",
    stepAutomaticallyGenerated:
      "This step was automatically generated. Activities are managed at the rule level.",
    selectActivityRuleOrStep:
      "Select an activity, rule, or step to view details",
    selectRuleOrStep: "Select a rule or step to view details",
    addActivities: "Add Activities",
    selectActivities: "Select Activities",
    selectedActivities: "Selected Activities",
    noActivitiesSelected: "No activities selected",
    addSelected: "Add Selected ({count})",
    saveSelection: "Save Selection",
    activitiesAdded: "{count} activity added | {count} activities added",
    failedToAddActivities: "Failed to add activities",
    alreadyAssigned: "Already Assigned",

    processCoverage: "Process Coverage",
    coverage: "Coverage",
    frequency: "Frequency",
    failedToLoadOrderedActivities: "Failed to load ordered activities",
    noActivitiesInEventLog: "No activities in event log",
    timeRange: "Time Range",
    variant: "Variant",
    avgDuration: "Avg. Duration",
    noData: "No data",
    mean: "Mean",
    startTime: "Start Time",
    caseHeatmap: "Case Duration Matrix",
    selectCasesToAnalyze: "Select cases above to view the heatmap.",
    selectCaseForDetails: "Select a case to view details.",
    noCasesForHeatmap: "No steps found for the selected cases.",
    cases: "Cases",
    caseDetails: "Case Details",
    stepInstances: "Steps",
    eventLog: "Event Log",
    eventLogEntries: "Event Log Entries",
    currentData: "Current Data",
    noCurrentData: "No current data available",
    loadingCurrentDataFailed: "Failed to load current data",

    // Scheduled Analysis
    scheduledAnalyses: "Scheduled Analyses",
    scheduledAnalysis: "Scheduled Analysis",
    searchSchedules: "Search schedules...",
    addSchedule: "Add Schedule",
    editSchedule: "Edit Schedule",
    cloneSchedule: "Clone Schedule",
    scheduleName: "Schedule Name",
    scheduleDescription: "Schedule Description",
    noDescription: "No description provided",
    cronExpression: "Schedule",
    cronExpressionPlaceholder: "Define schedule",
    cronInUtc: "All times are in UTC",
    nextExecution: "Next Execution",
    lastExecution: "Last Execution",
    affectedTables: "Affected Tables",
    selectTables: "Select Tables",
    selectedTables: "Selected Tables",
    searchTables: "Search tables...",
    noTablesFound: "No tables found",
    allTablesInDatabase: "All tables in database",
    allTables: "All tables",
    specificTables: "Specific tables",
    tableCount: "{count} table | {count} tables",
    scheduleCreated: "Schedule created successfully",
    scheduleUpdated: "Schedule updated successfully",
    scheduleDeleted: "Schedule deleted successfully",
    failedToCreateSchedule: "Failed to create schedule",
    failedToUpdateSchedule: "Failed to update schedule",
    failedToDeleteSchedule: "Failed to delete schedule",
    confirmDeleteSchedule: "Are you sure you want to delete this schedule?",
    active: "Active",
    inactive: "Inactive",
    noSchedulesFound: "No schedules found",
    noSchedulesYet: "No analysis schedules yet",
    noSchedulesYetDescription:
      "Create your first analysis schedule to automatically run data quality checks on a regular basis.",
    noSchedulesForYourSearch: "No schedules found for your search",
    noSchedulesForYourSearchDescription:
      "Try adjusting your search terms or clear the search to see all schedules.",
    createFirstSchedule: "Create Schedule",
    executionSuccess: "Success",
    executionError: "Error",
    executionRunning: "Running",
    executionQueued: "Queued",
    pleaseEnterScheduleName: "Please enter a schedule name",
    pleaseSelectTables: "Please select at least one table",
    syncDone: "Synced",
    lastSyncedAt: "Last synced",
    lastAnalyzedAt: "Last analyzed",
    refreshMetadata: "Refresh Metadata",
    refreshMetadataDescription:
      "This should be run when tables have been added, removed, or modified in the database. The refresh might take a few minutes to complete.",
    confirmRefreshMetadata:
      "Are you sure you want to refresh the metadata? This might take a few minutes to complete.",
    startAnalysisForAllTablesDescription:
      "Start analysis for all tables in the database. Depending on the number of tables, this may take several hours and heavily load the server.",
    backToDatabaseOverview: "Back to Database Overview",
    analysisSchedules: "Analysis Schedules",
    bpmn: "BPMN",
    variants: "Variants",
    variantHeatmapTitle: "Understanding Variant Performance & Bottlenecks",
    variantHeatmapDescription:
      "This table breaks down the different paths (variants) your process takes and shows the average time spent on each individual step. To help you instantly pinpoint delays, the duration of each step is color-coded by comparing it to its normal performance across all cases:",
    variantHeatmapMoreInfo: "More Info",
    variantHeatmapHowToUse:
      "Scan the table for yellow and red highlights to quickly diagnose inefficiencies. This allows you to see not only which specific process paths are taking too long, but exactly which steps within those paths are causing the bottleneck.",
    howToUse: "How to use this view",
    variantLegendNormal: "Normal",
    variantLegendNormalDesc:
      "The step completes within the expected average time.",
    variantLegendElevated: "Elevated",
    variantLegendElevatedDesc:
      "The step is noticeably slower in this variant (exceeds the historical average + 1 standard deviation).",
    variantLegendCritical: "Critical",
    variantLegendCriticalDesc:
      "The step is severely delayed in this variant (exceeds the historical average + 3 standard deviations).",

    caseHeatmapTitle: "Understanding Case Duration & Bottlenecks",
    caseHeatmapDescription:
      "This matrix shows each case's actual time spent on every process step. The color of each cell reflects how that specific case compares to the average duration for that step across all cases:",
    caseHeatmapHowToUse:
      "Select one or more cases from the table above to load the matrix. Scan for yellow and red cells to identify which steps caused delays in a particular case, and compare cases side-by-side to spot outliers.",
    caseLegendNormalDesc:
      "This case's step completed within the expected average time.",
    caseLegendElevatedDesc:
      "This case took noticeably longer on this step than the average (exceeds the average + 1 standard deviation).",
    caseLegendCriticalDesc:
      "This case was severely delayed on this step (exceeds the average + 3 standard deviations).",

    // Schedule Jobs
    scheduleDetails: "Schedule Details",
    scheduleJobs: "Schedule Executions",
    previousRun: "Previous Run",
    nextRun: "Next Run",
    filterByStatus: "Filter by status",
    allStatuses: "All statuses",
    tableName: "Table Name",
    startedAt: "Started At",
    completedAt: "Completed At",
    noJobsFound: "No jobs found",
    failedToLoadJobs: "Failed to load jobs",
    confirmCancelJob: "Are you sure you want to cancel this job?",
    jobCancelled: "Job cancelled successfully",
    failedToCancelJob: "Failed to cancel job",
    executionCancelled: "Cancelled",
    actions: "Actions",
    no: "No",
    errorMessage: "Error Message",
    error_connection_pool_full:
      "Too many parallel requests. Please try again later.",
    error_timeout_connection:
      "Connection timeout. The database did not respond in time.",
    error_internal_error: "An internal error occurred.",
    error_connection_failed:
      "Failed to connect to the database. Please check your connection and try again.",
    // Field filters
    filters: "Filters",
    reset: "Reset",
    scoreRange: "Score Range",
    evaluation: "Evaluation",
    evaluationGood: "Good",
    evaluationOk: "OK",
    evaluationBad: "Bad",
    evaluationUnknown: "Unknown",
    dataType: "Data Type",
    selectDataTypes: "Select data types",
    all: "All",
    activeOnly: "Active Only",
    inactiveOnly: "Inactive Only",
    stopAnalysisForAllTables: "Stop Analysis for All Tables",
    stopAnalysisForAllTablesDescription:
      "Stop all currently running analysis for all tables in the database. This will halt any ongoing analyses but will not delete existing results.",
    analysisStartedForAllTables: "Analysis started for all tables",
    analysisStoppedForAllTables: "Analysis stopped for all tables",
    stopAllAnalysis: "Stop All Analysis",
    activateAllFields: "Activate All Fields",
    activateAllFieldsDescription:
      "Activate all fields in this table for data quality analysis. Only active fields will be included in analysis runs.",
    deactivateAllFields: "Deactivate All Fields",
    deactivateAllFieldsDescription:
      "Deactivate all fields in this table from data quality analysis. Deactivated fields will be excluded from future analysis runs.",
    allFieldsActivated: "All fields have been activated",
    allFieldsDeactivated: "All fields have been deactivated",
    tableSettings: "Table Settings",
    caseExplorer: "Case Explorer",
    anomaliesDashboard: "Anomaly Dashboard",
    anomalies: "Anomalies",
    anomalyDetails: "Anomaly Details",
    anomalyType: "Anomaly Type",
    criticality: "Criticality",
    checked: "Checked",
    noAnomaliesFound: "No anomalies found",
    noAnomalySelected: "Select an anomaly to view its details",
    noAnomalyDetails: "No anomaly details available",
    unnamedAnomaly: "Unnamed anomaly",
    stepDurationOutliers: "Step Duration Outlier",
    processDeviations: "Process Deviation",
    anomalyLevelLow: "Low",
    anomalyLevelMedium: "Medium",
    anomalyLevelHigh: "High",
    unchecked: "Unchecked",
    processStep: "Process Step",
    meanDuration: "Mean Duration",
    median: "Median",
    standardDeviation: "Standard Deviation",
    deviationDistribution: "Deviation from Mean",
    percentileDistribution: "Percentile Distribution",
    percentile: "Percentile",
    additionalMetadata: "Additional Metadata",
    noDeviationDistributionData:
      "Mean duration and standard deviation are required to render this distribution",
    noPercentileData: "No percentile data available for this anomaly",
    affectedCases: "Affected Cases",
    anomalyAffectedCaseSummary: "Step: {processStep} in case {case}",
    noAffectedCases: "No affected cases linked to this anomaly",
    noAffectedCasesFound: "Linked cases could not be resolved",
    noAnomalyDistributionData: "No anomaly distribution data available",
    anomalyDistributionBelowMinus50: "< -50%",
    anomalyDistributionBelowMinus10: "< -10%",
    anomalyDistributionBelow10: "< 10%",
    anomalyDistributionBelow50: "< 50%",
    anomalyDistributionAbove50: "> 50%",
    totalCases: "Total Cases",
    stepDurationDistribution: "Step Duration Distribution",
    noHistogramData: "No histogram data available",
    anomalyStatusSaved: "Anomaly status updated",
    failedToUpdateAnomaly: "Failed to update anomaly",
    confirmStopAllJobs: "Are you sure you want to stop all running analyses?",
    confirmStopAllJobsForSchedule:
      "Are you sure you want to stop all running analyses for this schedule?",
    caseStepVisualization: "Sequence of Steps",
    processStepDurations: "Duration of Process Steps",
    anomalyDashboardLegendTitle: "Understanding Criticality Colors",
    anomalyDashboardLegendDescription:
      "Each step's histogram is color-coded based on how far a case's duration deviates from the mean duration of that step:",
    anomalyLegendLowDesc:
      "Within ± 2 standard deviations of the mean (normal range)",
    anomalyLegendMediumDesc:
      "Between ± 2 and ± 3 standard deviations of the mean (elevated deviation)",
    anomalyLegendHighDesc:
      "More than ± 3 standard deviations from the mean (critical deviation)",
    anomalyLegendStdDev: "Standard Deviation",
    anomalyLegendStdDevDesc:
      "The shaded band shows the standard deviation range around the mean on the histogram.",

    // DQ Dashboard Items
    kpiPercentageItem: "KPI Score Chart",
    kpiTotalItem: "KPI Total Count",
    anomalousEntriesItem: "Anomalous Entries",
    selectDatabase: "Select Database",
    selectField: "Select Field",
    selectKpiIdentifier: "Select KPI",
    noKpiData: "No KPI data available",
    notConfigured: "Not configured",
    field: "Field",
    kpiError: "Error loading KPI",
    openAnalysis: "Open Analysis",
    lastUpdated: "Last updated",
    widgetTitle: "Title",
    widgetKpiName: "KPI Name",
    widgetDescription: "Description",
    widgetInformation: "Information",
    widgetTitlePlaceholder: "Default: field name",
    widgetKpiNamePlaceholder: "Default: KPI identifier",

    // Log Configurations
    configurations: "Configurations",
    addConfiguration: "Add Configuration",
    configurationDeleted: "Configuration deleted",
    configurationCreated: "Configuration created",
    caseIdentifier: "Case Id column",
    database: "Database",
    pleaseSelectDatabase: "Please select a database",
    pleaseSelectTable: "Please select a table",
    pleaseEnterCaseIdentifier: "Please enter a case identifier",
    deleteConfigurationConfirm: "Delete this configuration?",
    noConfigurations: "No configurations",

    // RCA Settings
    rootCauseAnalysis: "Root cause analysis",
    noRootCauseResults: "No root cause analysis results found",
    rcaResult: "Result",
    RCASettings: "Root Cause Analysis Settings",
    RCASettingsDescription:
      "In the Root Cause Analysis Settings, you can configure the business attributes of a case (e.g., shift, supplier, material, ...) which are then used by the system for root cause analysis.",
    addRootCauseConfig: "Add Root Cause Config",
    sqlQuery: "SQL Query",
    attributes: "Attributes",
    attributeKey: "Key",
    attributeType: "Type",
    addAttribute: "Add Attribute",
    noRootCauseConfigs: "No root cause configurations",
    rootCauseConfigSaved: "Root cause configuration saved",
    rootCauseConfigDeleted: "Root cause configuration deleted",
    deleteRootCauseConfigConfirm: "Delete this root cause configuration?",
    sqlQueryRequired: "SQL query must not be empty",
    attributeKeyRequired: "All attribute keys must not be empty",

    // RCA Parameters / Values table
    parameter: "Parameter",
    parameterType: "Type",
    effectSize: "Effect Size",
    effectSizeLabel: "Significance",
    pValue: "P-Value",
    isSignificant: "Significant",
    significant: "Yes",
    notSignificant: "No",
    negligible: "Negligible",
    small: "Small",
    medium: "Medium",
    large: "Large",
    allEffectSizes: "All",
    parameterValues: "Parameter Values",
    anomalyRate: "Anomaly Rate",
    baselineRate: "Baseline Rate",
    relativeRisk: "Relative Risk",
    rank: "Rank",
  },
  de: {
    processMining: "Prozessanalyse",
    processMiningDescription: "Anwendung zur Analyse von Prozessdaten",
    dataQuality: "Datenqualität",
    dataQualityDescription: "Analyse und Verbesserung der Datenqualität",
    overallQualityScore: "Gesamtbewertung der Qualität",
    tablesCount: "Anzahl der Tabellen",
    averageScore: "Durchschnittliche Bewertung",
    percentOfRecordsHaveMissingValues:
      "{percent}% der Datensätze haben fehlende Werte",
    qualityIssues: "Qualitätsprobleme",
    fieldAnalysis: "Feldanalyse",
    startAnalysis: "Analyse starten",
    analysisNotStartedYetMessage:
      "Die Analyse wurde nicht gestartet. Klicken Sie auf {0}, um die Analyse zu starten.",
    analysisFailedMessage:
      "Die Analyse ist fehlgeschlagen. Klicken Sie auf {0}, um die Analyse erneut zu versuchen.",
    tableAnalysisStatusinitial: "Nicht gestartet",
    tableAnalysisStatusanalyzing: "In Bearbeitung",
    tableAnalysisStatusdone: "Abgeschlossen",
    tableAnalysisStatuserror: "Fehlgeschlagen",
    tableAnalysisStatusdeactivated: "Deaktiviert",
    overallScore: "Gesamtbewertung",
    distinctValues: "Anzahl unterschiedlicher Werte",
    missingValues: "Fehlende Werte",
    blankStrings: "Leere Zeichenfolgen",
    analysisAlreadyRunning: "Die Analyse läuft bereits.",
    nOfmEntriesAffected: "{n} von {m} Einträgen sind betroffen",
    columnOrder: "Spaltenreihenfolge",
    numericOutliers: "Numerische Ausreißer",
    inconsistentNumbers: "Inkonstante Zahlen",
    inconsistentDates: "Inkonsistente Datumsangaben",
    invalidEmails: "Ungültige E-Mail-Adressen",
    processLogs: "Prozessprotokolle",
    processLogsDescription: "Verwalten von Prozessereignisprotokollen",
    noEventLogsFound: "Keine Prozessprotokolle gefunden",
    entries: "Einträge",
    firstEntryDate: "Erster Eintrag",
    lastEntryDate: "Letzter Eintrag",
    caseId: "Fall-ID",
    activity: "Aktivität | Aktivitäten",
    timestamp: "Zeitstempel",
    endTime: "Ende",
    activityLogs: "Aktivitäten",
    nonEmptyEntries: "Non-null Einträge",

    numericOutliersNegated: "Werte innerhalb des Normbereichs",
    blankStringsNegated: "Nicht-leere Strings",
    missingValuesNegated: "Non-null Einträge",
    inconsistentNumbersNegated: "Konsistente Zahlen",
    inconsistentDatesNegated: "Konsistente Daten",
    invalidEmailsNegated: "Gültige E-Mail-Adressen",
    analysisNotStarted: "Analyse nicht gestartet",
    errorAnalyzing: "Fehler bei der Analyse",
    analyzing: "In Bearbeitung",
    analyzed: "Analysiert",
    noAnalysis: "Keine Analyse",
    analysisStarted: "Analyse gestartet",
    syncingStarted: "Synchronisierung gestartet",
    deleted: "Gelöscht",
    tableDeleted: "Diese Tabelle wurde aus der Datenbank gelöscht",
    syncing: "Synchronisiere",
    syncError: "Fehler bei der Synchronisierung",

    valid: "Valide",
    anomaliesDashboard: "Anomalie-Dashboard",
    anomalies: "Anomalien",
    anomalyDetails: "Anomaliedetails",
    anomalyType: "Anomalietyp",
    criticality: "Kritikalität",
    checked: "Geprüft",
    noAnomaliesFound: "Keine Anomalien gefunden",
    noAnomalySelected: "Wählen Sie eine Anomalie aus, um Details anzuzeigen",
    noAnomalyDetails: "Keine Anomaliedetails verfügbar",
    unnamedAnomaly: "Unbenannte Anomalie",
    stepDurationOutliers: "Ausreißer bei Schrittdauern",
    processDeviations: "Prozessabweichung",
    anomalyLevelLow: "Niedrig",
    anomalyLevelMedium: "Mittel",
    anomalyLevelHigh: "Hoch",
    unchecked: "Nicht geprüft",
    processStep: "Prozessschritt",
    meanDuration: "Mittlere Dauer",
    median: "Median",
    standardDeviation: "Standardabweichung",
    deviationDistribution: "Abweichung vom Mittelwert",
    percentileDistribution: "Perzentilverteilung",
    percentile: "Perzentil",
    additionalMetadata: "Zusätzliche Metadaten",
    noDeviationDistributionData:
      "Mittlere Dauer und Standardabweichung sind erforderlich, um diese Verteilung darzustellen",
    noPercentileData: "Für diese Anomalie sind keine Perzentildaten verfügbar",
    affectedCases: "Betroffene Fälle",
    anomalyAffectedCaseSummary: "Schritt {processStep} im Fall {case}",
    noAffectedCases: "Mit dieser Anomalie sind keine Fälle verknüpft",
    noAffectedCasesFound: "Verknüpfte Fälle konnten nicht geladen werden",
    noAnomalyDistributionData: "Keine Verteilungsdaten für Anomalien verfügbar",
    anomalyDistributionBelowMinus50: "< -50%",
    anomalyDistributionBelowMinus10: "< -10%",
    anomalyDistributionBelow10: "< 10%",
    anomalyDistributionBelow50: "< 50%",
    anomalyDistributionAbove50: "> 50%",
    totalCases: "Gesamtfälle",
    stepDurationDistribution: "Schritt-Dauern",
    noHistogramData: "Keine Histogrammdaten verfügbar",
    anomalyStatusSaved: "Anomaliestatus aktualisiert",
    failedToUpdateAnomaly: "Anomalie konnte nicht aktualisiert werden",
    newAnalysis: "Neue Analyse",
    pmNoVariantSelected:
      "Bitte wählen Sie mindestens eine Variante aus, um das BPMN-Diagramm anzuzeigen.",
    pmNoCaseSelected:
      "Bitte wählen Sie einen Fall aus, um das BPMN-Diagramm anzuzeigen.",
    noStepInstances: "Keine Prozessschritte für diesen Fall gefunden.",
    ongoingStep: "Laufend (kein Endzeitpunkt erfasst)",
    start: "Start",
    end: "Ende",
    duration: "Dauer",
    variantFilter: "Varianten",
    caseFilter: "Fall",
    nEvents: "{n} Ereignisse",
    selectAll: "Alle auswählen",
    selectAllTablesConfirm:
      "Möchten Sie alle {count} Tabellen auswählen? Dadurch werden alle verbleibenden Tabellen geladen.",
    case: "Fall | Fälle",
    selectCase: "Fall auswählen",
    downloadBpmn: "BPMN herunterladen",
    zoomIn: "Vergrößern",
    zoomOut: "Verkleinern",
    resetZoom: "Zoom zurücksetzen",
    operation: "Operation",
    editActivity: "Aktivität bearbeiten",

    processVariants: "Prozessvarianten",
    kpiThresholdsInfo:
      "Diese Schwellenwerte bestimmen die Farbcodierung der KPI-Anzeige (Rot/Gelb/Grün). Der beste zu erreichende Wert ist 100.",

    // KPI Filter translations
    editKpiFilters: "KPI-Filter bearbeiten",
    editTableFilters: "Tabellenfilter bearbeiten",
    tableFiltersDescription:
      "Tabellenfilter gelten für alle Felder während der Analyse. Sie filtern die Zeilen, die für die Qualitätsmetriken der gesamten Tabelle berücksichtigt werden.",
    filterOperator: "Operator",
    filterField: "Feld",
    filterCondition: "Bedingung",
    filterValue: "Wert",
    addFilter: "Filter hinzufügen",
    removeFilter: "Filter entfernen",
    filterOperatorAND: "UND",
    filterOperatorOR: "ODER",
    filterConditionEquals: "Gleich",
    filterConditionNotEquals: "Ungleich",
    filterConditionGreaterThan: "Größer als",
    filterConditionLessThan: "Kleiner als",
    filterConditionGreaterThanOrEqual: "Größer oder gleich",
    filterConditionLessThanOrEqual: "Kleiner oder gleich",
    filterConditionContains: "Enthält",
    filterConditionNotContains: "Enthält nicht",
    noFiltersConfigured: "Keine Filter konfiguriert",
    filtersActive: "{count} Filter aktiv",
    selectFieldFirst: "Zuerst Feld auswählen",
    filtersNotApplied:
      "Einige Filter wurden noch nicht auf die aktuelle Analyse angewendet. Bitte aktualisieren Sie, um die Änderungen zu übernehmen.",
    refreshToApplyFilters: "Aktualisieren, um Filter anzuwenden",
    startAnalysisForAllTables: "Analyse für alle Tabellen starten",
    startAnalysisForAllTablesConfirm:
      "Analyse für alle Tabellen starten? Dies kann einige Zeit in Anspruch nehmen.",
    processWorkbench: "Prozess-Workbench",
    rawActivities: "Roh-Aktivitäten",
    processSteps: "Prozessschritte",
    totalActivities: "Gesamt-Aktivitäten",
    unmappedActivities: "Nicht zugeordnet",
    listView: "Liste",
    flowView: "Fluss",
    eventsView: "Ereignisse",
    selectCaseToViewEvents:
      "Wählen Sie einen Fall aus, um Ereignisse anzuzeigen",
    failedToLoadEventEntries: "Fehler beim Laden der Ereigniseinträge",
    noEventEntriesFound: "Keine Ereigniseinträge gefunden",
    createProcessStep: "Prozessschritt erstellen",
    deleteRule: "Regel löschen",
    activityDetails: "Aktivitätsdetails",
    processStepDetails: "Prozessschrittdetails",
    details: "Details",
    selectActivityOrStep:
      "Wählen Sie eine Aktivität oder einen Prozessschritt aus, um Details anzuzeigen",
    assignedToStep: "Zugeordnet zu Schritt",
    strategy: "Strategie",
    manualAssignment: "Manuelle Zuordnung",
    assignedActivities: "Zugeordnete Aktivitäten",
    noActivitiesAssigned: "Noch keine Aktivitäten zugeordnet",
    noStepsYet: "Keine Prozessschritte gefunden",
    noActivitiesFound: "Keine Aktivitäten gefunden",
    processStepCreated: "Prozessschritt erfolgreich erstellt",
    stepNameUpdated: "Schrittname erfolgreich aktualisiert",
    variantNameUpdated: "Variantenname erfolgreich aktualisiert",
    strategyUpdated: "Strategie erfolgreich aktualisiert",
    stepDeleted: "Schritt erfolgreich gelöscht",
    activityAssigned: "Aktivität erfolgreich zugeordnet",
    activityUnassigned: "Aktivität erfolgreich entfernt",
    failedToCreateStep: "Fehler beim Erstellen des Prozessschritts",
    failedToUpdateStep: "Fehler beim Aktualisieren des Prozessschritts",
    failedToUpdateVariant: "Fehler beim Aktualisieren der Variante",
    failedToDeleteStep: "Fehler beim Löschen des Prozessschritts",
    failedToAssignActivity: "Fehler beim Zuordnen der Aktivität",
    failedToUnassignActivity: "Fehler beim Entfernen der Aktivität",
    pleaseEnterStepName: "Bitte geben Sie einen Schrittnamen ein",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Schritt löschen möchten?",
    workbench: "Workbench",
    columnChange: "Spaltenänderung",
    timeWindow: "Zeitfenster",
    stateBased: "Zustandsbasiert",
    stateBasedSettings: "Zustandsbasierte Einstellungen",
    editStateBasedStrategy: "Strategie bearbeiten",
    stateBasedStrategyDescription:
      "Die zustandsbasierte Strategie gruppiert Ereignisse in Prozessschritte basierend auf Bedingungen. Ereignisse werden zusammengefasst, wenn sie innerhalb des angegebenen Zeitfensters auftreten und alle Bedingungen erfüllen.",
    condition: "Bedingung | Bedingungen",
    addCondition: "Bedingung hinzufügen",
    noConditionsSet: "Keine Bedingungen gesetzt",
    selectTable: "Tabelle auswählen",
    column: "Spalte | Spalten",
    maxTimeBetweenEvents: "Maximale Zeit zwischen Ereignissen",
    useDragAndDropToAssignAnActivityToAStep:
      "Verwenden Sie Drag & Drop, um eine Aktivität einem Schritt zuzuordnen",

    // Process Step Rules
    processStepRules: "Prozessschrittregeln",
    createProcessStepRule: "Prozessschrittregel erstellen",
    createRule: "Regel erstellen",
    enterRuleName: "Regelname eingeben",
    noRulesYet: "Keine Prozessschrittregeln gefunden",
    ruleDetails: "Regeldetails",
    stepDetails: "Schrittdetails",
    generatedSteps: "Generierte Schritte",
    generatedBy: "Generiert von Regel",
    ruleCreated: "Regel erfolgreich erstellt",
    ruleNameUpdated: "Regel erfolgreich aktualisiert",
    ruleDeleted: "Regel erfolgreich gelöscht",
    failedToCreateRule: "Fehler beim Erstellen der Regel",
    failedToUpdateRule: "Fehler beim Aktualisieren der Regel",
    failedToDeleteRule: "Fehler beim Löschen der Regel",
    confirmDeleteRule: "Sind Sie sicher, dass Sie diese Regel löschen möchten?",
    assignedToRule: "Zugeordnet zu Regel",
    stepsGenerated: "{count} Schritt | {count} Schritte",
    ignoreInAnalysis: "In Analyse ignorieren",
    stepMetadata: "Schritt-Metadaten",
    selectActivityRuleOrStep:
      "Wählen Sie eine Aktivität, Regel oder Schritt aus, um Details anzuzeigen",
    selectRuleOrStep:
      "Wählen Sie eine Regel oder Schritt aus, um Details anzuzeigen",
    addActivities: "Aktivitäten hinzufügen",
    selectActivities: "Aktivitäten auswählen",
    selectedActivities: "Ausgewählte Aktivitäten",
    noActivitiesSelected: "Keine Aktivitäten ausgewählt",
    addSelected: "Ausgewählte hinzufügen ({count})",
    saveSelection: "Auswahl speichern",
    activitiesAdded:
      "{count} Aktivität hinzugefügt | {count} Aktivitäten hinzugefügt",
    failedToAddActivities: "Fehler beim Hinzufügen der Aktivitäten",
    alreadyAssigned: "Bereits zugeordnet",

    processCoverage: "Prozessabdeckung",
    coverage: "Abdeckung",
    frequency: "Häufigkeit",
    failedToLoadOrderedActivities:
      "Fehler beim Laden der geordneten Aktivitäten",
    noActivitiesInEventLog: "Keine Aktivitäten im Ereignisprotokoll",
    timeRange: "Zeitfenster",

    // Scheduled Analysis
    scheduledAnalyses: "Geplante Analysen",
    scheduledAnalysis: "Geplante Analyse",
    searchSchedules: "Zeitpläne durchsuchen...",
    addSchedule: "Zeitplan hinzufügen",
    editSchedule: "Zeitplan bearbeiten",
    cloneSchedule: "Zeitplan klonen",
    scheduleName: "Zeitplanname",
    scheduleDescription: "Zeitplanbeschreibung",
    noDescription: "Keine Beschreibung vorhanden",
    cronExpression: "Zeitplan",
    cronExpressionPlaceholder: "Zeitplan definieren",
    cronInUtc:
      "Alle Zeiten sind in UTC um Problemen durch Zeitumstellungen vorzubeugen",
    nextExecution: "Nächste Ausführung",
    lastExecution: "Letzte Ausführung",
    affectedTables: "Betroffene Tabellen",
    selectTables: "Tabellen auswählen",
    selectedTables: "Ausgewählte Tabellen",
    searchTables: "Tabellen suchen...",
    noTablesFound: "Keine Tabellen gefunden",
    allTablesInDatabase: "Alle Tabellen in der Datenbank",
    allTables: "Alle Tabellen",
    specificTables: "Bestimmte Tabellen",
    tableCount: "{count} Tabelle | {count} Tabellen",
    scheduleCreated: "Zeitplan erfolgreich erstellt",
    scheduleUpdated: "Zeitplan erfolgreich aktualisiert",
    scheduleDeleted: "Zeitplan erfolgreich gelöscht",
    failedToCreateSchedule: "Fehler beim Erstellen des Zeitplans",
    failedToUpdateSchedule: "Fehler beim Aktualisieren des Zeitplans",
    failedToDeleteSchedule: "Fehler beim Löschen des Zeitplans",
    confirmDeleteSchedule:
      "Sind Sie sicher, dass Sie diesen Zeitplan löschen möchten?",
    active: "Aktiv",
    inactive: "Inaktiv",
    noSchedulesFound: "Keine Zeitpläne gefunden",
    noSchedulesYet: "Noch keine Analyse-Zeitpläne vorhanden",
    noSchedulesYetDescription:
      "Erstellen Sie Ihren ersten Analyse-Zeitplan, um automatisch regelmäßige Datenqualitätsprüfungen durchzuführen.",
    noSchedulesForYourSearch: "Keine Zeitpläne für Ihre Suche gefunden",
    noSchedulesForYourSearchDescription:
      "Versuchen Sie, Ihre Suchbegriffe anzupassen oder löschen Sie die Suche, um alle Zeitpläne zu sehen.",
    createFirstSchedule: "Zeitplan erstellen",
    executionSuccess: "Erfolgreich",
    executionError: "Fehler",
    executionRunning: "Läuft",
    executionQueued: "Warteschlange",
    pleaseEnterScheduleName: "Bitte geben Sie einen Zeitplannamen ein",
    pleaseSelectTables: "Bitte wählen Sie mindestens eine Tabelle aus",
    syncDone: "Synchronisiert",
    lastSyncedAt: "Zuletzt synchronisiert",
    lastAnalyzedAt: "Zuletzt analysiert",
    refreshMetadata: "Metadaten aktualisieren",
    refreshMetadataDescription:
      "Sollte ausgeführt werden, wenn Tabellen in der Datenbank hinzugefügt, entfernt oder geändert wurden. Die Aktualisierung kann einige Minuten dauern.",
    confirmRefreshMetadata:
      "Sind Sie sicher, dass Sie die Metadaten aktualisieren möchten? Dies kann einige Minuten dauern.",
    startAnalysisForAllTablesDescription:
      "Analyse für alle Tabellen in der Datenbank starten. Je nach Anzahl der Tabellen kann dies einige Stunden in Anspruch nehmen, und den Server stark belasten.",
    backToDatabaseOverview: "Zurück zur Datenbankübersicht",
    analysisSchedules: "Analyse-Zeitpläne",
    variant: "Variante",
    avgDuration: "Durchschn. Dauer",
    noData: "Keine Daten",
    mean: "Mittelwert",
    startTime: "Startzeit",
    caseHeatmap: "Fall-Dauer Matrix",
    selectCasesToAnalyze: "Wählen Sie Fälle aus, um die Heatmap anzuzeigen.",
    selectCaseForDetails: "Wählen Sie einen Fall aus, um Details anzuzeigen.",
    noCasesForHeatmap:
      "Für die ausgewählten Fälle wurden keine Schritte gefunden.",
    cases: "Fälle",
    caseDetails: "Falldetails",
    stepInstances: "Schritte",
    eventLog: "Prozessprotokoll",
    eventLogEntries: "Aktivitäten",
    currentData: "Aktuelle Daten",
    noCurrentData: "Keine aktuellen Daten verfügbar",
    loadingCurrentDataFailed: "Fehler beim Laden der aktuellen Daten",
    bpmn: "BPMN",
    variants: "Varianten",
    variantHeatmapTitle: "Varianten-Performance & Engpässe verstehen",
    variantHeatmapDescription:
      "Diese Tabelle schlüsselt die verschiedenen Wege (Varianten) Ihres Prozesses auf und zeigt die durchschnittliche Zeit, die für jeden einzelnen Schritt aufgewendet wird. Um Verzögerungen sofort zu erkennen, wird die Dauer jedes Schritts farblich codiert und mit der normalen Leistung über alle Fälle hinweg verglichen:",
    variantHeatmapMoreInfo: "Mehr Info",
    variantHeatmapHowToUse:
      "Scannen Sie die Tabelle nach gelben und roten Markierungen, um Ineffizienzen schnell zu diagnostizieren. So können Sie nicht nur erkennen, welche Prozesspfade insgesamt zu lange dauern, sondern auch genau, welche Schritte innerhalb dieser Pfade den Engpass verursachen.",
    howToUse: "So verwenden Sie diese Ansicht",
    variantLegendNormal: "Normal",
    variantLegendNormalDesc:
      "Der Schritt wird innerhalb der erwarteten Durchschnittszeit abgeschlossen.",
    variantLegendElevated: "Erhöht",
    variantLegendElevatedDesc:
      "Der Schritt ist in dieser Variante spürbar langsamer (überschreitet den historischen Durchschnitt + 1 Standardabweichung).",
    variantLegendCritical: "Kritisch",
    variantLegendCriticalDesc:
      "Der Schritt ist in dieser Variante stark verzögert (überschreitet den historischen Durchschnitt + 3 Standardabweichungen).",

    caseHeatmapTitle: "Falldauer & Engpässe verstehen",
    caseHeatmapDescription:
      "Diese Matrix zeigt die tatsächliche Zeit, die jeder Fall für jeden Prozessschritt benötigt hat. Die Farbe jeder Zelle gibt an, wie dieser Fall im Vergleich zur durchschnittlichen Dauer dieses Schritts über alle Fälle abschneidet:",
    caseHeatmapHowToUse:
      "Wählen Sie einen oder mehrere Fälle aus der obigen Tabelle aus, um die Matrix zu laden. Achten Sie auf gelbe und rote Felder, um zu erkennen, welche Schritte bei einem bestimmten Fall zu Verzögerungen geführt haben, und vergleichen Sie Fälle nebeneinander, um Ausreißer zu identifizieren.",
    caseLegendNormalDesc:
      "Dieser Fall hat den Schritt innerhalb der erwarteten Durchschnittszeit abgeschlossen.",
    caseLegendElevatedDesc:
      "Dieser Fall hat bei diesem Schritt deutlich länger gebraucht als der Durchschnitt (überschreitet den Durchschnitt + 1 Standardabweichung).",
    caseLegendCriticalDesc:
      "Dieser Fall war bei diesem Schritt stark verzögert (überschreitet den Durchschnitt + 3 Standardabweichungen).",

    stopAnalysisForAllTables: "Analyse für alle Tabellen stoppen",
    stopAnalysisForAllTablesDescription:
      "Beenden Sie alle aktuell laufenden Analysen für alle Tabellen in der Datenbank. Dies wird alle laufenden Analysen stoppen, aber vorhandene Ergebnisse nicht löschen.",

    stopAllAnalysis: "Alle Analysen stoppen",
    // Schedule Jobs
    scheduleDetails: "Zeitplan Details",
    scheduleJobs: "Zeitplan Ausführungen",
    previousRun: "Vorheriger Lauf",
    nextRun: "Nächster Lauf",
    filterByStatus: "Nach Status filtern",
    allStatuses: "Alle Status",
    tableName: "Tabellenname",
    startedAt: "Gestartet",
    completedAt: "Abgeschlossen",
    noJobsFound: "Keine Analysen gefunden",
    failedToLoadJobs: "Fehler beim Laden der Analysen",
    confirmCancelJob:
      "Sind Sie sicher, dass Sie diese Analyse stoppen möchten?",
    jobCancelled: "Analyse erfolgreich abgebrochen",
    failedToCancelJob: "Fehler beim Abbrechen der Analyse",
    executionCancelled: "Abgebrochen",
    actions: "Aktionen",
    no: "Nein",
    errorMessage: "Fehlermeldung",
    error_connection_pool_full:
      "Zu viele parallele Anfragen. Bitte versuchen Sie es später erneut.",
    error_timeout_connection:
      "Verbindungs-Timeout. Die Datenbank hat nicht rechtzeitig geantwortet.",
    error_internal_error: "Ein interner Fehler ist aufgetreten.",
    error_connection_failed:
      "Fehler beim Verbinden mit der Datenbank. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",

    // Field filters
    filters: "Filter",
    reset: "Zurücksetzen",
    scoreRange: "Bewertungsbereich",
    evaluation: "Bewertung",
    evaluationGood: "Gut",
    evaluationOk: "OK",
    evaluationBad: "Schlecht",
    evaluationUnknown: "Unbekannt",
    dataType: "Datentyp",
    selectDataTypes: "Datentypen auswählen",
    all: "Alle",
    activeOnly: "Nur Aktive",
    inactiveOnly: "Nur Inaktive",

    analysisStartedForAllTables: "Analyse für alle Tabellen gestartet",
    analysisStoppedForAllTables: "Analyse für alle Tabellen gestoppt",
    activateAllFields: "Alle Felder aktivieren",
    activateAllFieldsDescription:
      "Aktivieren Sie alle Felder in dieser Tabelle für die Datenqualitätsanalyse. Nur aktive Felder werden in die Analyseläufe einbezogen.",
    deactivateAllFields: "Alle Felder deaktivieren",
    deactivateAllFieldsDescription:
      "Deaktivieren Sie alle Felder in dieser Tabelle von der Datenqualitätsanalyse. Deaktivierte Felder werden von zukünftigen Analyseläufen ausgeschlossen.",
    allFieldsActivated: "Alle Felder wurden aktiviert",
    allFieldsDeactivated: "Alle Felder wurden deaktiviert",
    tableSettings: "Tabelleneinstellungen",
    caseExplorer: "Fall-Explorer",
    confirmStopAllJobs:
      "Sind Sie sicher, dass Sie alle laufenden Analysen stoppen möchten?",
    confirmStopAllJobsForSchedule:
      "Sind Sie sicher, dass Sie alle Analysen für diesen Zeitplan stoppen möchten?",
    caseStepVisualization: "Abfolge der Schritte",
    processStepDurations: "Dauer der Prozessschritte",
    anomalyDashboardLegendTitle: "Farbcodierung der Kritikalität",
    anomalyDashboardLegendDescription:
      "Das Histogramm jedes Schritts wird basierend darauf farbcodiert, wie stark die Dauer vom Mittelwert abweicht:",
    anomalyLegendLowDesc:
      "Innerhalb von ± 2 Standardabweichungen vom Mittelwert (Normalbereich)",
    anomalyLegendMediumDesc:
      "Zwischen ± 2 und ± 3 Standardabweichungen vom Mittelwert (erhöhte Abweichung)",
    anomalyLegendHighDesc:
      "Mehr als ± 3 Standardabweichungen vom Mittelwert (kritische Abweichung)",
    anomalyLegendStdDev: "Standardabweichung",
    anomalyLegendStdDevDesc:
      "Der blaue Bereich zeigt den Standardabweichungsbereich im Histogramm an.",

    // DQ Dashboard Items
    kpiPercentageItem: "KPI Bewertungsdiagramm",
    kpiTotalItem: "KPI Gesamtanzahl",
    anomalousEntriesItem: "Anomale Einträge",
    selectDatabase: "Datenbank auswählen",
    selectField: "Feld auswählen",
    selectKpiIdentifier: "KPI auswählen",
    noKpiData: "Keine KPI-Daten verfügbar",
    notConfigured: "Nicht konfiguriert",
    field: "Feld",
    kpiError: "Fehler beim Laden des KPI",
    openAnalysis: "Analyse öffnen",
    lastUpdated: "Zuletzt aktualisiert",
    widgetTitle: "Titel",
    widgetKpiName: "KPI-Name",
    widgetDescription: "Beschreibung",
    widgetInformation: "Information",
    widgetTitlePlaceholder: "Standard: Feldname",
    widgetKpiNamePlaceholder: "Standard: KPI-Bezeichner",

    // Log Configurations
    configurations: "Konfigurationen",
    addConfiguration: "Konfiguration hinzufügen",
    configurationDeleted: "Konfiguration gelöscht",
    configurationCreated: "Konfiguration erstellt",
    caseIdentifier: "Fall-Id Spalte",
    database: "Datenbank",
    pleaseSelectDatabase: "Bitte Datenbank auswählen",
    pleaseSelectTable: "Bitte Tabelle auswählen",
    pleaseEnterCaseIdentifier: "Bitte Fall-Id Spalte eingeben",
    deleteConfigurationConfirm: "Diese Konfiguration löschen?",
    noConfigurations: "Keine Konfigurationen",

    // RCA Settings
    rootCauseAnalysis: "Ursachenanalyse",
    noRootCauseResults: "Keine Ursachenanalyse-Ergebnisse gefunden",
    rcaResult: "Ergebnis",
    RCASettings: "Ursachenanalyse Konfiguration",
    RCASettingsDescription:
      "In den Ursachenanalyse-Konfigurationen können fachliche Eigenschaften eines Falls (z.B. Schicht, Lieferant, Material, ...) konfiguriert werden, welche dann vom System für die Ursachenanalyse verwendet werden.",
    addRootCauseConfig: "Ursachenanalyse-Konfiguration hinzufügen",
    sqlQuery: "SQL-Abfrage",
    attributes: "Attribute",
    attributeKey: "Schlüssel",
    attributeType: "Typ",
    addAttribute: "Attribut hinzufügen",
    noRootCauseConfigs: "Keine Ursachenanalyse-Konfigurationen",
    rootCauseConfigSaved: "Ursachenanalyse-Konfiguration gespeichert",
    rootCauseConfigDeleted: "Ursachenanalyse-Konfiguration gelöscht",
    deleteRootCauseConfigConfirm:
      "Diese Ursachenanalyse-Konfiguration löschen?",
    sqlQueryRequired: "SQL-Abfrage darf nicht leer sein",
    attributeKeyRequired: "Alle Attributschlüssel dürfen nicht leer sein",

    // RCA Parameters / Values table
    parameter: "Parameter",
    parameterType: "Typ",
    effectSize: "Effektgröße",
    effectSizeLabel: "Signifikanz",
    pValue: "P-Wert",
    isSignificant: "Signifikant",
    significant: "Ja",
    notSignificant: "Nein",
    negligible: "Vernachlässigbar",
    small: "Klein",
    medium: "Mittel",
    large: "Groß",
    allEffectSizes: "Alle",
    parameterValues: "Parameterwerte",
    anomalyRate: "Anomalierate",
    baselineRate: "Basisrate",
    relativeRisk: "Relatives Risiko",
    rank: "Rang",
  },
};
